// extracted by css-extract-rspack-plugin
export default {"list":"SocialLinks-module__list__kkyUo","iconLink":"SocialLinks-module__iconLink__TSxai","icon":"SocialLinks-module__icon__GnyEV"};